export default __webpack_public_path__ + "static/media/mental.8e3df582.svg";